import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProfileService } from '../data-access/user.service';

/**
 * Protects subscribed areas from access when subscription is inactive.
 * Redirects inactive users to the Store page so they can renew.
 */
export const subscriptionGuard: CanActivateFn = () => {
  const profile = inject(ProfileService);
  const router = inject(Router);

  if (!profile.isSubscriptionInactive()) {
    return true;
  }

  return profile.isAdmin()
    ? router.createUrlTree(['/store'])
    : router.createUrlTree(['/error'], { queryParams: { type: 'subscription-inactive' } });
};
